/* SK Article — blog article template interactions.
   Scroll-reveal, macro count-up, print, share, mobile sticky bar.
   No Liquid data needed (share uses location.href + document.title). */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll reveal ---- */
  var fx = document.querySelectorAll('.ska-fx');
  if (fx.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      fx.forEach(function (el) { el.classList.add('is-vis'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-vis'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      fx.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---- macro count-up ---- */
  var counts = document.querySelectorAll('.ska-count');
  function animateCount(el) {
    var target = parseInt(el.getAttribute('data-n'), 10) || 0;
    if (reduce) { el.textContent = target; return; }
    var start = null, dur = 900;
    function tick(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased);
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  if (counts.length) {
    if (!('IntersectionObserver' in window)) {
      counts.forEach(animateCount);
    } else {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { animateCount(e.target); cio.unobserve(e.target); }
        });
      }, { threshold: 0.5 });
      counts.forEach(function (el) { cio.observe(el); });
    }
  }

  /* ---- print ---- */
  document.querySelectorAll('[data-ska-print]').forEach(function (btn) {
    btn.addEventListener('click', function () { window.print(); });
  });

  /* ---- share ---- */
  var toast = document.querySelector('.ska-toast');
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-show'); }, 1800);
  }
  function doShare() {
    var data = { title: document.title, url: location.href };
    if (navigator.share) {
      navigator.share(data).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(location.href).then(function () { showToast('Link copied'); });
    } else {
      showToast(location.href);
    }
  }
  document.querySelectorAll('[data-ska-share]').forEach(function (btn) {
    btn.addEventListener('click', doShare);
  });

  /* ---- mobile sticky bar ---- */
  var bar = document.querySelector('.sk-article-sticky');
  if (bar) {
    var hero = document.querySelector('.sk-article-hero');
    var related = document.querySelector('.sk-article-related') || document.querySelector('.sk-article-closing');
    function onScroll() {
      var pastHero = hero ? (hero.getBoundingClientRect().bottom < 40) : (window.scrollY > 400);
      var nearEnd = related ? (related.getBoundingClientRect().top < window.innerHeight) : false;
      if (pastHero && !nearEnd) bar.classList.add('is-show');
      else bar.classList.remove('is-show');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
